import { FC } from "react";
import Entity, { IEntity } from "./Entity";

export type EntitySetProps = {
  entities: IEntity[],
  setEntity: React.Dispatch<React.SetStateAction<IEntity | null>>,
};

const EntitySet: FC<EntitySetProps> = (props) => {
  if (props.entities.length === 0) { return null; }

  const entities: JSX.Element[] = props.entities.map<JSX.Element>((entity) => {
    return <li key={`entity-${entity.id}`}><Entity entity={entity} handleClick={props.setEntity}/></li>;
  });

  return (
    <ul>
      {entities}
    </ul>
  );
}

export default EntitySet;
